/* ==========================================================================
   Oji Página — Recorrido: GSAP ScrollTrigger reveal
   Numbers pop, media rises, copy staggers in as each step enters the viewport.
   No-JS / reduced-motion / missing-GSAP all degrade to the static layout.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.journeyAnim === 'done') return;
    section.dataset.journeyAnim = 'done';

    section.querySelectorAll('.oji-journey__step').forEach(function (step) {
      var number = step.querySelector('.oji-journey__number');
      var media = step.querySelector('.oji-journey__media');
      var texts = step.querySelectorAll('.oji-journey__step-title, .oji-journey__step-body');

      var tl = window.gsap.timeline({
        scrollTrigger: { trigger: step, start: 'top 78%', once: true }
      });
      if (number) {
        tl.from(number, { scale: 0.4, autoAlpha: 0, duration: 0.5, ease: 'back.out(2)' });
      }
      if (media) {
        tl.from(media, { y: 44, autoAlpha: 0, duration: 0.7, ease: 'power3.out' }, '-=0.25');
      }
      if (texts.length) {
        tl.from(texts, { y: 24, autoAlpha: 0, duration: 0.55, stagger: 0.1, ease: 'power3.out' }, '-=0.45');
      }
    });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    document.querySelectorAll('.oji-journey').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run for a section re-rendered by the customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oji-journey');
    if (section && window.gsap && window.ScrollTrigger) initSection(section);
  });
})();
